export default __webpack_public_path__ + "static/media/al-ikhtayar-1.66ee7d1a.png";